<template>
  <div class="store-delivery-wrapper">
    <p class="store-delivery-wrapper__details">
      {{ title }}
    </p>
    <ul v-if="deliveryMethod">
      <li
        v-if="deliveryMethod === 'pickup'"
        class="store-delivery-wrapper__details-item"
      >
        <svgicon
          class="store-delivery-wrapper__details-icon"
          name="Delivery/CollectinStore"
        /> Hämta i butik
      </li>
      <li
        v-if="deliveryMethod === 'homedelivery'"
        class="store-delivery-wrapper__details-item"
      >
        <svgicon
          class="store-delivery-wrapper__details-icon"
          name="Delivery/HomeDelivery"
        /> Hemleverans
      </li>
    </ul>
    <ul v-if="hasPrePayment || hasStorePayment">
      <li
        v-if="hasPrePayment"
        class="store-delivery-wrapper__details-item"
      >
        <svgicon
          class="store-delivery-wrapper__details-icon"
          name="Controls/Check"
        /> Förskottsbetalning
      </li>
      <li
        v-if="hasStorePayment"
        class="store-delivery-wrapper__details-item"
      >
        <svgicon
          class="store-delivery-wrapper__details-icon"
          name="Controls/Check"
        /> Betala i butik
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StoreDeliveryWrapper',
  props: {
    title: {
        type: String,
        default: ""
      },
    selectedDeliveryMethod: {
      type: String,
      default: ""
    },
    hasPrePayment: {
      type: Boolean,
      default: false
    },
    hasStorePayment: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    deliveryMethod (){
      return this.selectedDeliveryMethod.toLowerCase()
    }
  }
}
</script>

<style lang="scss">
.store-delivery-wrapper {
  text-align: left;

  @include media-breakpoint-down(md) {
    &:last-of-type {
      padding-bottom: 0;
    }
  }

  &__details {
    @include font(text, 2, "black");

    display: flex;
    flex-direction: row;
    margin: 0 0 0.25rem;
    text-transform: uppercase;

    &-item {
      line-height: 24px;

      svg {
        fill: #3a3a3a;
      }
    }

    &-icon {
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 0.5rem;
    }
  }
}
</style>
